import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=63d21fa4&scoped=true&"
import script from "./Pay.vue?vue&type=script&lang=js&"
export * from "./Pay.vue?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=63d21fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d21fa4",
  null
  
)

export default component.exports